import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

type EventType = { _id: string; name: string; eventTypeId: string }
type Competition = { _id: string; name: string; betfairId: string }

export function FetchMarketPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [eventTypes, setEventTypes] = useState<EventType[]>([])
  const [competitions, setCompetitions] = useState<Competition[]>([])
  const [eventTypeId, setEventTypeId] = useState('')
  const [competitionId, setCompetitionId] = useState('')

  useEffect(() => {
    void sessionApi
      .getAllEventType()
      .then((res) => {
        const data = res.data as EventType[]
        setEventTypes(Array.isArray(data) ? data : [])
      })
      .catch(() => toast.error('Failed to load event types'))
  }, [toast])

  const onEventType = (id: string) => {
    setEventTypeId(id)
    setCompetitionId('')
    setCompetitions([])
    const et = eventTypes.find((e) => e._id === id || e.eventTypeId === id)
    const key = et?.eventTypeId || id
    if (!key) return
    void sessionApi
      .getAllCompetition(key)
      .then((res) => {
        const data = res.data as Competition[]
        if (Array.isArray(data) && data.length) {
          setCompetitions(data)
          toast.success('All Competitions Fetched Successfully')
        } else {
          setCompetitions([])
          toast.error('No Competition Found')
        }
      })
      .catch(() => toast.error('No Competition Found'))
  }

  const onCompetition = (id: string) => {
    setCompetitionId(id)
    const c = competitions.find((x) => x._id === id || x.betfairId === id)
    const key = c?.betfairId || id
    if (!key) return
    void sessionApi
      .getAllMarketsForCompetition(key)
      .then((res) => {
        const data = res.data as { _id: string }[]
        if (Array.isArray(data) && data.length) {
          toast.success('All Matches Fetched Successfully')
        } else {
          toast.error('No Market Found')
        }
      })
      .catch(() => toast.error('No Market Found'))
  }

  return (
    <div>
      <PageHead title="Fetch Market" onBack={() => navigate('/sessionmarket')} />
      <div className="sm-row" style={{ marginBottom: 12 }}>
        <select className="w7-input" value={eventTypeId} onChange={(e) => onEventType(e.target.value)}>
          <option value="">Select Event Type</option>
          {eventTypes.map((et) => (
            <option key={et._id} value={et.eventTypeId || et._id}>
              {et.name}
            </option>
          ))}
        </select>
        {competitions.length > 0 ? (
          <select
            className="w7-input"
            value={competitionId}
            onChange={(e) => onCompetition(e.target.value)}
          >
            <option value="">Select Competition</option>
            {competitions.map((c) => (
              <option key={c._id} value={c.betfairId || c._id}>
                {c.name}
              </option>
            ))}
          </select>
        ) : null}
      </div>
    </div>
  )
}
